import { NgModule } from '@angular/core';
import { AnimateTextComponent } from './animate-text.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        AnimateTextComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        AnimateTextComponent
    ]
})
export class NcAnimateTextModule { }